import Sprite, { SpriteParams } from './sprite';

export interface SpriteSheetParams extends SpriteParams {
  frameCount?: number;
  stageCount?: number;
  numberOfFramesBeforeNextStep?: number;
  spriteWidth?: number;
  spriteHeight?: number;
  loop?: boolean;
  defaultFrameIndex?: number;
  defaultStageIndex?: number;
}

export default class SpriteSheet extends Sprite implements SpriteSheetParams {
  frameCount!: number; // Image number per line in the image
  stageCount!: number; // Line number in the image
  numberOfFramesBeforeNextStep = 10; // frames per image
  spriteWidth!: number;
  spriteHeight!: number;
  loop = false;
  defaultFrameIndex: number = 0;
  defaultStageIndex: number = 0;

  ended = false;
  maxNumberOfFramesBeforeNextStep: number;
  sx!: number;
  sy!: number;
  swidth!: number;
  sheight!: number;
  currentFrameIndex: number = 0;
  currentStageIndex: number = 0;

  constructor(params: SpriteSheetParams) {
    super(params);
    this.applyParams(params);
    this.maxNumberOfFramesBeforeNextStep = this.numberOfFramesBeforeNextStep;
    this.reset();
  }

  reset(): void {
    this.currentFrameIndex = this.defaultFrameIndex;
    this.currentStageIndex = this.defaultStageIndex;
  }

  getPreviousImage(): void {
    this.currentFrameIndex--;
    if (this.currentFrameIndex <= 0) //frameIndex reset
    {
      this.currentFrameIndex = this.defaultFrameIndex;
      this.currentStageIndex--;
      if (this.currentStageIndex <= 0) {
        if (this.loop)
          this.reset();
        else
          this.ended = true;
      }
    }

    this.sx = this.currentFrameIndex * this.spriteWidth / this.frameCount;
    this.sy = this.currentStageIndex * this.spriteHeight / this.stageCount;
    this.swidth = this.spriteWidth / this.frameCount;
    this.sheight = this.spriteHeight / this.stageCount;
  }

  getNextImage(): void {
    this.currentFrameIndex++;
    if (this.currentFrameIndex >= this.frameCount) //frameIndex reset
    {
      this.currentFrameIndex = 0;
      this.currentStageIndex++;
      if (this.currentStageIndex >= this.stageCount) {
        if (this.loop)
          this.reset();
        else
          this.ended = true;
      }
    }

    this.sx = this.currentFrameIndex * this.spriteWidth / this.frameCount;
    this.sy = this.currentStageIndex * this.spriteHeight / this.stageCount;
    this.swidth = this.spriteWidth / this.frameCount;
    this.sheight = this.spriteHeight / this.stageCount;
  }

  updateFrameIndex(): boolean {
    this.numberOfFramesBeforeNextStep--;
    if (this.numberOfFramesBeforeNextStep <= 0) {
      this.numberOfFramesBeforeNextStep = this.maxNumberOfFramesBeforeNextStep;
      return true;
    }
    else
      return false;
  }

  nextTick(): void {
    if (this.updateFrameIndex())
      this.getNextImage();
  }

  previousTick(): void {
    if (this.updateFrameIndex())
      this.getPreviousImage();
  }

  draw(): CanvasRenderingContext2D {
    if (this.width === undefined) {
      this.width = this.element.width;
      this.widthDefault = this.width;
    }
    if (this.height === undefined) {
      this.height = this.element.height;
      this.heightDefault = this.height;
    }

    const zoomRatio = this.element?.scene?.camera?.zoomRatio || 1;
    let { width, height } = this;
    if (this.ignoreScale) {
      width = this.widthDefault / zoomRatio;
      height = this.heightDefault / zoomRatio;
    }
    const {
      image,
      offsetCenterX,
      offsetCenterY,
    } = this;
    this.context.drawImage(
      image,
      this.sx,
      this.sy,
      this.swidth,
      this.sheight,
      -width / 2 + offsetCenterX / zoomRatio,
      -height / 2 + offsetCenterY / zoomRatio,
      width,
      height
    );
    return this.context;
  }
}
